import { render, staticRenderFns } from "./ProvidersReport.vue?vue&type=template&id=5372bbd3&"
import script from "./ProvidersReport.vue?vue&type=script&lang=js&"
export * from "./ProvidersReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports